
import React from 'react';
import { Box, Typography, Grid, CardContent, Card, Button, TextField } from '@mui/material';
import colors from '../../../constants/colors';
import { parseFloatTotal } from '../../../utils/utilsT';
import NumberFormatCustom from '../../NumberFormatCustom';



const calculatePercent = (percent: number, num: number) => {
    return parseFloat(`${(percent / 100) * num}`).toFixed(2);
}
const optionsTipping = [
    {
        title: "",
        value: 20,
    },
    {
        title: "",
        value: 25,
    },
    {
        title: "",
        value: 30,
    }
]

interface TipFieldProps {
    value: number
    amount: number
    isActive: boolean
    onClick(e): void
}

const TippingField: React.FC<TipFieldProps> = (props) => {


    return (
        <Grid item xs={4} >
            <Button
                variant="contained"
                fullWidth
                // className={`${props.isActive  && "Mui-selected"}`}
                style={{
                    minHeight: 70,
                    backgroundColor: props.isActive && colors.blue_2
                }}

                onClick={props.onClick}
            >
                <Box display="flex" flexDirection="column">

                    <Typography variant="h5" > {props.value}%</Typography>
                    <Typography variant="caption" > ${parseFloatTotal(calculatePercent(Number(props.value), Number(props.amount)))}</Typography>
                </Box>
            </Button>
        </Grid>
    )
}
export type ITipProps = {
    amount: number
    onChange?(number: number): void
    onChangeSelectOption(string): void
    noTip(): void
}

const FormTipPayment: React.FC<ITipProps> = (props) => {
    const [showInputCustomTip, setShowInputCustomTip] = React.useState(false);
    const [tipeValue, setTipeValue] = React.useState(0);

    const [selectedOption, setSelectedOption] = React.useState("");


    const onChange = (value) => {
        setTipeValue(value)
        props.onChange(value)
    }


    return (
        <Box mt={5} >
            <Box mt={2} mb={2}>
                <Typography variant="h4" textAlign="center">Add Optional Tip</Typography>
            </Box>
            <Grid container spacing={1}>

                {optionsTipping.map((item, index) => {
                    let amount = calculatePercent(item.value, props.amount)
                    return (
                        <TippingField key={index} isActive={Number(amount) == tipeValue ? true : false} value={item.value} amount={props.amount} onClick={(e) => {
                            setShowInputCustomTip(false)
                            setSelectedOption(`${item.value}`)
                            props.onChangeSelectOption(`${item.value}`)
                            onChange(amount)
                        }} />
                    )
                })}
            </Grid>
            <Box mt={1}>
                <Button
                    variant="outlined"
                    fullWidth
                    style={{
                        minHeight: 50,
                        backgroundColor: selectedOption == "customTip" && colors.buttonLight
                    }}
                    onClick={() => {
                        if (!showInputCustomTip) {
                            onChange(tipeValue)
                        }
                        setSelectedOption("customTip")
                        props.onChangeSelectOption(`customTip`)
                        setShowInputCustomTip(!showInputCustomTip)
                    }}>
                    <Typography fontSize="md" > Custom Tip Amount</Typography>
                </Button>
                {showInputCustomTip &&
                    <Box mt={2} mb={2} pt={2} pb={2}>

                        <TextField
                            variant="standard"
                            fullWidth
                            value={tipeValue}

                            InputProps={{
                                inputComponent: NumberFormatCustom as any,
                                inputProps: {

                                    fixedDecimalScale: true,
                                    decimalScale: 2,
                                    mask: "_",
                                    thousandSeparator: true,
                                    prefix: '$'
                                }

                            }}
                            onChange={(event: any) => {
                                let value = event.target.value

                                onChange(value)
                            }}
                        />
                    </Box>
                }
                <Button
                    variant="outlined"
                    fullWidth
                    style={{
                        minHeight: 50,
                        marginTop: 2,
                        backgroundColor: selectedOption == "noTip" && colors.buttonLight
                    }}
                    onClick={() => {
                        setTipeValue(0)
                        setShowInputCustomTip(false)
                        props.onChangeSelectOption(`noTip`)
                        setSelectedOption("noTip")
                        props.noTip()
                    }}
                >
                    <Typography fontSize="md" > No Tip</Typography>
                </Button>
            </Box>
        </Box>
    );
}

export default FormTipPayment
export { FormTipPayment }